import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('sbc_configuration', '/sbc_configurations')
const reducer = generator.generate()

export default reducer
